import { render } from "./ManagerGroupsRolesView.vue?vue&type=template&id=54df4bc4"
import script from "./ManagerGroupsRolesView.vue?vue&type=script&lang=js"
export * from "./ManagerGroupsRolesView.vue?vue&type=script&lang=js"

import "./ManagerGroupsRolesView.vue?vue&type=style&index=0&id=54df4bc4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__